var Stats = require('/src/lib/util/math/stats');

module.exports = function(individualCards, handSize, confidencePct) {
	var pct = confidencePct || 0.70;

	var manaCards = individualCards.filter(function(c) {
		return c.type && c.type.match(/land/i);
	});

	this.supplyCurve = [];
	for (var turn = 0; turn < individualCards.length - handSize; turn++) {
		this.supplyCurve.push(Stats.drawRange(pct,
			turn * 1 + handSize * 1,
			manaCards.length,
			individualCards.length
		));
	}

	var manaCostCards = individualCards.filter(function(c) {
		return Boolean(c.cmc);
	});

	this.demandCurve = this.supplyCurve.map(function(supply, i) {
		return manaCostCards.reduce(function(accumulator, card) {
			if (card.cmc) {
				if (Number(card.cmc) > supply.lower) {
					accumulator.max += 1;
				}
				if (Number(card.cmc) > supply.upper) {
					accumulator.min += 1;
				}
			}
			return accumulator;
		}, {min:0, max:0});
	});

	// return the threshold/turn at which a given percentage
	// of cards will probably be playable, based on mana drawn.
	this.threshold = function(pctPlayable) {
		let search = Math.round(pctPlayable * manaCostCards.length);
		let turn = 0;
		for (; turn < individualCards.length - handSize; turn++) {
			var playable = manaCostCards.length - this.demandCurve[turn].max;
			if (playable >= search) break;
		}
		return turn;
	};

	this.speed = (
		(1 - (this.threshold(0.50) / 1) ** 4 ) +
		(1 - (this.threshold(0.85) / 3) ** 4 ) +
		(1 - (this.threshold(1.00) / 5) ** 4 )
	) / 3;

};
